import { Pipe, PipeTransform } from '@angular/core';
import { MenuItemDto } from '../../../services/akita/menu-item-schema/menu-item.dto';
import { DataParser } from "../../../services";

@Pipe({
  name: 'getMenuSelectedChildren'
})
export class GetMenuSelectedChildrenPipe implements PipeTransform {

  transform(menuDto: MenuItemDto, menuDtos: MenuItemDto[]): string {

    let classes = 'on-hover no-drag pl-1 ';
    if (menuDto.isCurrentPage) {
      const selectedChild = menuDtos.find(m => m.isCurrentPage && menuDto.menuItem.id === m.menuItem.data.parentMenuItem.iv[0]);
      if (!selectedChild) {
        classes += ' is-selected';
      }
    }
    return classes;

  }
}
